<main class="container-cco">
	@if (options.length === 0) {
		<section class="form-box">
			<label class="component-field-input-checkbox show" [class.check-error]="hasError">
				<section class="check-section-body">
					<div class="check-icon">
						<div class="check-light"></div>
						<p class="text-font text-sm">{{ labelConfig['label'] }}</p>
						<section class="check-section-icon">
							<div class="icon-box check-icon-validation"></div>
						</section>
					</div>
					@for (item of requestList; track item) {
						<div>
							<label class="check-template show">
								<input
									(change)="changeLabelValue($event)"
									[disabled]="disabled"
									type="checkbox"
									class="check-field"
									[value]="item.id"
								/>
								<span class="overflow-control-indicator"></span>
								<span class="chk-text">{{ formatLabel(item) }}</span>
							</label>
						</div>
					}
				</section>
			</label>
			<button
				class="btn-primary btn-type-2 w-[5%] mt-[25px]"
				[disabled]="optionsSelected.length === 0"
				(click)="selectItems()"
			>
				Adicionar
			</button>
		</section>
	}

	@if (options.length > 0) {
		<section>
			<!-- button back -->
			<div class="btn-primary btn-type-3 cursor-pointer" (click)="back()">
				<div class="icon-box text-gray-200">
					<lbca-icon name="lucide:chevron-down" />
				</div>
			</div>
			@for (opt of options; track opt; let i = $index) {
				<div class="box-item mt-[30px] flex flex-col justify-center">
					<div class="box-info flex justify-between p-[20px] mb-[50px] bg-gray-50 rounded-lg">
						<div class="flex">
							<span class="img-quantidade mr-[10px] light-white"></span>
							<div class="box-title flex flex-col text-gray-700 text-[8px]">
								<p class="text-xs">Quantidade</p>
								<p class="text-xs mt-[5px]">{{ opt.payList.length }}</p>
							</div>
						</div>
						<div class="flex">
							<span class="img-total-inicial mr-[10px] light-white"></span>
							<div class="box-title flex flex-col text-gray-700 text-[8px]">
								<p class="text-xs">Total</p>
								<p class="text-xs mt-[5px]">{{ calculateTotal(opt.payList) | currency: 'BRL' }}</p>
							</div>
						</div>
					</div>
					<lbca-table [table]="mountTable(opt.payList, opt.type_id)"></lbca-table>
					<div class="flex flex-col mt-[20px] mb-[20px]">
						<div class="flex">
							<button
								(click)="toggleInputs(opt)"
								class="btn-type-3 btn-primary ml-[7px]"
								[class.btn-danger]="hasError"
							>
								<lbca-icon name="lucide:plus" size="small" class="text-gray-50" />
							</button>
							<span class="h-[32px] flex ml-[12px] mt-[4px] text-sm text-gray-700">
								Desmembramento
							</span>
						</div>
					</div>
					@if (opt.show) {
						<div class="box-input mt-[10px]">
							<div class="flex">
								<!-- select com as opções de desmembramento -->
								<lbca-select
									class="mr-[10px]"
									[label]="'Desmenbramento'"
									[require]="false"
									[options]="dismemberOptions"
									(changeValue)="changeValue($event, 'type', opt)"
									[value]="opt.typeDis"
								></lbca-select>
								<!-- input valor do desmembramento -->
								<lbca-input-text
									[label]="'Valor'"
									[tabeled]="false"
									[labeled]="true"
									[error]="errors ? errors : []"
									[require]="false"
									[maskInput]="'CURRENCY_BR'"
									(changeValue)="changeValue($event, 'value', opt)"
									[value]="opt.valueDis"
								></lbca-input-text>
								<div class="flex cursor-pointer mt-[10px]">
									<button
										(click)="addField(opt, opt.id)"
										[disabled]="!valueField.type || !valueField.value"
										class="btn-primary btn-type-2 ml-[25px] load-action"
										type="button"
									>
										Adicionar
									</button>
								</div>
							</div>
						</div>
					}
					<!-- campos dos desmembramento adicionados -->
					@if (opt.dismember) {
						<div class="box-table mt-[20px] flex flex-wrap">
							@for (field of opt.dismember; track field) {
								<div>
									@if (opt.id === field.referenceId) {
										<div class="flex items-center mr-[20px] mt-[30px] mb-[12px]">
											<lbca-input-text
												[labeled]="false"
												[componetHelperIconLeftStyle]="'img-quantidade ' + 'light-white'"
												[copyContent]="false"
												[label]="getLabel(field?.type, dismemberOptions)"
												[value]="setMask(maskcurrencyBr, field.value)"
											></lbca-input-text>
											<span
												(click)="removeItem(field.id, opt.dismember)"
												class="icon-trash cursor-pointer btn-hover"
											></span>
										</div>
									}
								</div>
							}
						</div>
					}
					@if (options.length > 1) {
						<div class="divider"></div>
					}
				</div>
			}
		</section>
	}
</main>
